"use client";

import { useTranslations } from "next-intl";
import ImageCarousel, { type CarouselImage } from "@/components/home/ImageCarousel";

// Add/remove entries here to change what shows in the gym intro carousel.
const GYM_INTRO_IMAGES: CarouselImage[] = [
  { src: "/img/teretana.webp", alt: "Saiyan Gym unutrašnjost — žuti akcenti, sprave i fitness oprema" },
  { src: "/img/saiyan7.webp", alt: "Saiyan Gym unutrašnjost — red crno-žutih sprava za trening snage" },
  { src: "/img/saiyan8.webp", alt: "Saiyan Gym unutrašnjost — zidni mural Kame House s Majstorom Roshijem iznad stalka s bučicama" },
];

export default function GymIntroSection() {
  const t = useTranslations("GymIntro");
  const categories = t.raw("categories") as string[];
  const bullets = t.raw("bullets") as string[];

  return (
    <section className="mx-auto max-w-6xl px-6 py-12 sm:px-8 lg:px-10">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-stretch lg:gap-8">

        {/* Left — image */}
        <div className="w-full flex-shrink-0 lg:w-[49%]">
          <ImageCarousel images={GYM_INTRO_IMAGES} className="aspect-[6/5] lg:aspect-auto lg:h-full" />
        </div>

        {/* Right — text */}
        <div className="flex flex-col gap-6 lg:w-[51%]">

          {/* Heading */}
          <h2 className="text-4xl font-bold leading-none text-[#18181b] sm:text-5xl">
            {t("heading")}
          </h2>

          {/* Category pills */}
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <span
                key={cat}
                className="rounded-full border border-[#E4E4E7] bg-[#f4f4f5] p-3 text-center text-base font-medium leading-none text-[#18181b]"
              >
                {cat}
              </span>
            ))}
          </div>

          {/* Paragraph */}
          <p className="text-base leading-normal text-[#18181b]">
            {t("paragraph")}
          </p>

          {/* Bullet list */}
          <ul className="flex flex-col gap-3">
            {bullets.map((item) => (
              <li key={item} className="flex items-start gap-2 text-base leading-relaxed text-[#3f3f46]">
                <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[#18181b]" aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>

        </div>
      </div>
    </section>
  );
}
